import {take, fork, cancel} from 'redux-saga/effects';
import {LOCATION_CHANGE, matchPath, parseSearchQueryParams} from '@computerrock/formation-router';
import routePaths from '../../routePaths';
import savaScreenTabs from '../savaScreenTabs';
import * as savaActionTypes from '../savaActionTypes';
import onSAVAMapClickSelectTowingDestination from './onSAVAMapClickSelectTowingDestination';

const savaMapTowingDestinationWatcher = function* savaMapTowingDestinationWatcher() {
    mainFlow: while (true) {
        const {payload} = yield take(savaActionTypes.START_SAVA_MAP_TOWING_DESTINATION_WATCHER);

        const onSAVAMapClickSelectTowingDestinationTask = yield fork(onSAVAMapClickSelectTowingDestination, payload);

        while (true) {
            const watcherTerminationAction = yield take([
                savaActionTypes.STOP_SAVA_MAP_TOWING_DESTINATION_WATCHER,
                LOCATION_CHANGE,
            ]);

            if (watcherTerminationAction.type === savaActionTypes.STOP_SAVA_MAP_TOWING_DESTINATION_WATCHER) {
                yield cancel(onSAVAMapClickSelectTowingDestinationTask);
                continue mainFlow;
            }

            const {payload} = watcherTerminationAction;
            const {location} = payload;

            const savRouteMatch = matchPath(location.pathname, {
                path: routePaths.SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL,
                exact: true,
            });
            const {activeTab} = savRouteMatch ? parseSearchQueryParams(location.search) : {};
            if (!savRouteMatch || activeTab !== savaScreenTabs.TOWING_DESTINATION) {
                yield cancel(onSAVAMapClickSelectTowingDestinationTask);
                continue mainFlow;
            }
        }
    }
};

export default savaMapTowingDestinationWatcher;
